import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FiMail, FiUser, FiBook, FiSend, FiCheck } from 'react-icons/fi';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './PaymentConfirmation.css';

const PaymentConfirmation = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    course: 'DYLORA 1+1 Internship Program'
  });
  
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const courseOptions = [
    'DYLORA 1+1 Training Program',
    'Web Development Training',
    'App Development Training',
    'Data Analysis Training',
    'Machine Learning Training',
    'Backend Development Training',
    'Digital Marketing Training',
    'Full Stack Development'
  ];

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    if (!formData.name || !formData.email || !formData.course) {
      setError('All fields are required');
      return;
    }

    if (!/\S+@\S+\.\S+/.test(formData.email)) {
      setError('Please enter a valid email address');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('http://localhost:13000/api/email/send-payment-confirmation', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSuccess(true);
        setFormData({
          name: '',
          email: '',
          course: 'DYLORA 1+1 Internship Program'
        });
        
        // Reset success message after 5 seconds
        setTimeout(() => {
          setSuccess(false);
        }, 5000);
      } else {
        setError(data.message || 'Failed to send confirmation');
      }
    } catch (err) {
      console.error('Error:', err);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleEnrollClick = () => {
    window.location.href = '/#home';
  };

  return (
    <div className="payment-confirmation-page">
      <Header onEnrollClick={handleEnrollClick} />
      
      <main className="payment-confirmation-main">
        <div className="payment-container">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="payment-header"
          >
            <div className="payment-icon">
              <FiMail size={48} />
            </div>
            <h1>Payment Confirmation</h1>
            <p className="payment-subtitle">
              Send payment confirmation email to students
            </p>
          </motion.div>

          <div className="payment-content">
            {success ? (
              <motion.div
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                className="success-message"
              >
                <div className="success-icon">
                  <FiCheck size={48} />
                </div>
                <h3>Confirmation Sent Successfully!</h3>
                <p>Payment confirmation email has been sent to the student.</p>
                <button
                  onClick={() => setSuccess(false)}
                  className="send-another-btn black-btn-outline"
                >
                  Send Another Confirmation
                </button>
              </motion.div>
            ) : (
              <form onSubmit={handleSubmit} className="payment-form">
                <div className="form-group">
                  <label className="form-label">
                    <FiUser className="label-icon" />
                    Student Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter student's full name"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <FiMail className="label-icon" />
                    Student Email
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Enter student's email address"
                    required
                  />
                </div>

                <div className="form-group">
                  <label className="form-label">
                    <FiBook className="label-icon" />
                    Course/Program
                  </label>
                  <select
                    name="course"
                    value={formData.course}
                    onChange={handleChange}
                    className="form-select"
                    required
                  >
                    {courseOptions.map((course, index) => (
                      <option key={index} value={course}>
                        {course}
                      </option>
                    ))}
                  </select>
                </div>

                {error && (
                  <div className="error-message">
                    <FiSend className="error-icon" />
                    {error}
                  </div>
                )}

                <motion.button
                  type="submit"
                  className="submit-button black-btn"
                  disabled={loading}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  {loading ? (
                    <>
                      <div className="spinner"></div>
                      Sending...
                    </>
                  ) : (
                    <>
                      <FiSend className="button-icon" />
                      Send Confirmation Email
                    </>
                  )}
                </motion.button>

                <div className="form-note">
                  <p>
                    <strong>Note:</strong> This will send a professional payment confirmation email 
                    to the student with all program details.
                  </p>
                </div>
              </form>
            )}

            <div className="info-card">
              <h3>Email Preview</h3>
              <div className="preview-content">
                <p><strong>Subject:</strong> 🎉 Payment Confirmed - DYLORA Internship Program</p>
                <p><strong>To:</strong> {formData.email || 'student@example.com'}</p>
                <p><strong>Content Includes:</strong></p>
                <ul>
                  <li>Payment confirmation message</li>
                  <li>Program details and schedule</li>
                  <li>Student's enrollment information</li>
                  <li>WhatsApp group link for updates</li>
                  <li>Next steps and important dates</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default PaymentConfirmation;